import Window from "../window/Window.jsx";

function Home({ data, functions }) {

  function getAge(d1, d2) {
    d2 = d2 || new Date();
    d1 = d1.split("-");
    d1 = new Date(d1[1] + "/" + d1[0] + "/" + d1[2]);
    var diff = d2.getTime() - d1.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  }

  return (
    <Window
      title="Accueil"
      id="home"
      default_opened
    >
      <div>
        <img src={data.photo} id="avatar" />
        <div>
          <h3>
            {data.prénom} {data.nom_de_famille}
          </h3>
          <h3>{getAge(data.date_de_naissance)} ans</h3>
        </div>
      </div>
      <div>
        <p>{data.description}</p>
      </div>
      <div>
        {data.détails.map((d, i) => (
          <p key={d + "-" + i}>{d}</p>
        ))}
        <p>📧 {data.mail}</p>
        <p>
          🌐{" "}
          <a href="https://pierre-lhoste.github.io/">
            https://pierre-lhoste.github.io/
          </a>
        </p>
      </div>
    </Window>
  );
}

export default Home;
